<!-- Header -->
<h1 mat-dialog-title>
  {{ element.chapter ? element.chapter.toString() + '. ' : '' }}
  {{ element.name }}
  <span class="button-group">

    <!-- Quality level dropdown -->
    <mat-form-field>
      <mat-label>test</mat-label>
      <mat-select [formControl]="qualityLevelForm">
        <mat-option *ngFor="let qualityLevel of qualityLevels" [value]="qualityLevel.value">
          {{ qualityLevel.displayName }}
          <span *ngIf="element.quality === qualityLevel.value">
            ({{ 'current' | translate: 'lowerCase' }})
          </span>
        </mat-option>
        <mat-select-trigger>
          {{ 'qualitylevel' | translate }}: {{ qualityLevelForm.value | qualityLevel: 'value' }}
        </mat-select-trigger>
      </mat-select>
    </mat-form-field>

  </span>
</h1>

<!-- Content -->
<div mat-dialog-content>
  
  <div class="compare" fxLayout="row">
    <div class="value value-current" fxFlex>
      <h5><strong>{{ 'valueCurrent' | translate }}</strong></h5>
      <div [innerHTML]="elementValueDiffs | safeHtml"></div>
    </div>
    
    <div class="value value-template" fxFlex #templateValueSelected>
      <h5><strong>{{ 'templatevalue' | translate }}</strong></h5>
      <div [innerHTML]="templateValue | safeHtml"></div>
    </div>
  </div>

</div>

<!-- Actions -->
<div mat-dialog-actions align="end">

  <button mat-button (click)="dialogRef.close()" tabindex="-1">
    {{ 'cancel' | translate }}
  </button>

  <button mat-flat-button tabindex="-1" (click)="submit()" color="primary" [disabled]="!authService.canUpdate('element')">
    {{ 'restoreTemplateValue' | translate }}
  </button>

</div>
